import { render, staticRenderFns } from "./indexMenu.vue?vue&type=template&id=0aa97218&scoped=true"
import script from "./indexMenu.vue?vue&type=script&lang=js"
export * from "./indexMenu.vue?vue&type=script&lang=js"
import style0 from "./indexMenu.vue?vue&type=style&index=0&id=0aa97218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa97218",
  null
  
)

export default component.exports